import React from 'react';
import CensorBar from './CensorBar';

// Top-of-sidebar brand block. Two valid forms:
//   variant="in-app"     → [BRAND] Censor Bar (Bone Pure / Obsidian)
//   variant="marketing"  → Lion crest + serif Aurum wordmark "MOGGED"
// DESIGN.md §6.1 SidebarBrandBlock.
const SidebarBrandBlock = ({ variant = 'in-app', wordmark = 'MOGGED' }) => {
  if (variant === 'marketing') {
    return (
      <div className="flex items-center gap-3">
        <LionCrest />
        <span
          className="font-display tracking-wide text-aurum"
          style={{ fontSize: '28px', lineHeight: 1 }}
        >
          {wordmark}
        </span>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-start gap-3">
      <CensorBar mode="BRAND" size="lg" />
      <div className="h-px w-20 bg-aurum" aria-hidden="true" />
    </div>
  );
};

// Minimal lion-bust mark. Phase 0 placeholder shape (geometric lion-head
// silhouette + censor bar across the eyes). Production replacement is a
// proper mark file in /assets — this glyph keeps the surface dependency-free.
const LionCrest = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    role="img"
    aria-label="MOGGED crest"
  >
    <path
      d="M20 5 C12 5 7 11 7 19 C7 27 12 34 20 36 C28 34 33 27 33 19 C33 11 28 5 20 5 Z"
      stroke="currentColor"
      strokeWidth="1.2"
      className="text-aurum"
      fill="none"
    />
    <path
      d="M14 14 L14 11 M20 14 L20 10 M26 14 L26 11"
      stroke="currentColor"
      strokeWidth="1.2"
      className="text-aurum"
    />
    <rect
      x="11"
      y="18"
      width="18"
      height="4"
      fill="currentColor"
      className="text-aurum"
    />
  </svg>
);

export default SidebarBrandBlock;
